import React from "react";
import styled, { keyframes } from "styled-components";
import PropTypes from "prop-types";

const neonGlow = (firstColor, secondColor) => keyframes`
  0% {
    box-shadow: 0 0 10px ${firstColor}, 0 0 20px ${firstColor}, 0 0 30px ${firstColor};
    border-color: ${firstColor};
  }
  50% {
    box-shadow: 0 0 15px ${secondColor}, 0 0 30px ${secondColor}, 0 0 45px ${secondColor};
    border-color: ${secondColor};
  }
  100% {
    box-shadow: 0 0 10px ${firstColor}, 0 0 20px ${firstColor}, 0 0 30px ${firstColor};
    border-color: ${firstColor};
  }
`;

// מסגרת ניאון דינמית
const NeonWrapper = styled.div`
  position: relative;
  display: inline-flex; /* שומר על גודל התוכן בלי מרווחים */
  align-items: center;
  justify-content: center;

  ${'' /* border: 4px solid ${(props) => props.firstColor || "#ff007f"}; */}
  border-radius: 15px;
  animation: ${(props) => neonGlow(props.firstColor, props.secondColor)} 3s infinite alternate;
  box-sizing: border-box; /* מונע הרחבה לא רצויה */
`;

const NeonGrid = ({ children, firstColor = "#ff007f", secondColor = "#00e0ff" }) => {
  return (
    <NeonWrapper firstColor={firstColor} secondColor={secondColor}>
      {children}
    </NeonWrapper>
  );
};

NeonGrid.propTypes = {
  children: PropTypes.node.isRequired,
  firstColor: PropTypes.string,
  secondColor: PropTypes.string,
};


export default NeonGrid;
